const muiTabsOverrides = {
  styleOverrides: {
    indicator: {
      height: '4px',
    },
  },
};

export default muiTabsOverrides;
